export default __webpack_public_path__ + "static/media/howtosellimg.8c80e304.jpg";